export { default as QuickBookingRestShort } from './QuickBookingRestShort'
